import { render, staticRenderFns } from "./Campaing.vue?vue&type=template&id=4d9f76ed"
import script from "./Campaing.vue?vue&type=script&lang=js"
export * from "./Campaing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports